<template>
  <div>
    <list
      v-loading="IsLoading"
      row-key="WorkDocId"
      ref="list"
      unit="工单管理"
      show-checkbox
      :page="page"
      :show-query="showQuery"
      :get-data-func="getDataFunc"
      max-height="500"
      v-if="trendShow"
      :queryParamsAppend="{ Stage: Stage }"
      @check-change="checkChange"
      :temp-params="tempParams"
      @getDataEnd="getDataEnd"
      @getDetail="viewImg"
      urlHash="production/ticketmanagement/injection/currency"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <img-dialog ref="imgDialog" :imgs="imgs" />
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import dpSelect from '@/components/production/clothmanagement/cloth/workorder/dpSelect'
import VueBarcode from 'vue-barcode'
import imgDialog from './imgDialog'

export default {
  mixins: [listMixin],
  components: { list, dpSelect, VueBarcode, imgDialog },
  props: {
    IsDialog: {
      type: Boolean,
      default: false
    },
    Stage: {
      type: Number,
      default: 0
    },
    OrderType: {
      type: String,
      default: '未下达'
    }
  },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  data() {
    return {
      api: require('@/api/production/workDoc').default,
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      pdApi: require('@/api/ba/product').default,
      IsLoading: true,
      tradeUnitList: [],
      trendShow: true,
      tempParams: {
        IsRelease: false
      },
      // params: {
      //   CustomerName: "",
      //   Stage: null, //注塑/胶件加工/配件装配/产品装配/产品组装
      //   OrderNo: "",
      //   WorkDocNo: "",
      //   CompletionStartDate: null,
      //   CompletionEndDate: null,
      //   DocStartDate: null,
      //   DocEndDate: null,
      //   WorkDocType: null,
      //   ProductType: null,
      //   ProductName: "",
      //   Status: null,
      // },
      isMB: this.$store.state.isMB,
      list: [],
      orderType: '未下达',
      restaurants: [],
      imgs: []
    }
  },
  created() {
    this.getProcessor()
    this.getwarehouseList()
    this.gettradeUnitList()
  },
  mounted() {
    // const findIndex = this.$refs.list.tableList.findIndex(item => item.tableName == "StartTime");
    // console.log("🚀 ~ mounted ~ this.$refs.list.tableList[findIndex]:", this.$refs.list.tableList[findIndex])
  },
  activated() {
    this.getRouterInfo()
  },
  watch: {
    OrderType(v) {
      this.orderType = v
    }
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.getDocList(params).then(res => {
          res.Data = res.Data.map(item => {
            return {
              ...item,
              isEditBtn: false,
              isEdit: false,
              isDp: item.ProductionType == 1 ? true : false, // 车间禁用状态
              isProductionDp: item.ProductionType == 0 ? true : false //加工商禁用状态
            }
          })

          this.IsLoading = false
          resolve(res)
        })
      })
    },
    getDataEnd(resData) {
      resData.forEach(item => {
        item.StartTime_disabled = true
      })
    },
    getRouterInfo() {
      if (this.$router.history.current.params) {
        this.tempParams.OrderNo = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.OrderNo
        }
        if (this.$router.history.current.params.type === '明细' && this.$router.history.current.params.DocType === '装配工单') {
          this.tempParams.WorkDocNo = {
            paramValueType: 'resetParamValue',
            isReset: true,
            value: this.$router.history.current.params.DocNo
          }
        }
        this.tempParams.ProductionType = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.ProductionType
        }
        this.tempParams.Ids = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.Ids
        }
        this.$refs.list.getData()
      }
    },
    /** 获取加工商 */
    getProcessor() {
      let that = this
      this.tradeUnitApi.list({ TradeUnitType: 3 }).then(res => {
        that.restaurants = res.Data.map(i => {
          return {
            value: i.FullName,
            id: i.TradeUnitId
          }
        })
      })
    },
    /** 获取预入仓 */
    getwarehouseList() {
      this.warehouseApi.list({}).then(res => {
        if (res.Code === 0) {
          this.warehouseList = res.Data
        }
      })
    },
    /** 获取加工商 */
    gettradeUnitList() {
      this.tradeUnitApi.list({ Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.tradeUnitList = res.Data
        }
      })
    },
    base64ToFile(dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    /** 获取产品图片 */
    async viewImg(row) {
      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg)
      const ImgUrl = res.Data
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！')
      let imgs = []
      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl))
        // imgs.push(imgBlob)
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs
      this.$refs.imgDialog.open()
    },
    color(row) {
      if (row.Status == 7) return 'c-lightgray'
      if (row.Status == 6) return 'c-danger'
    },
    checkChange(list) {
      this.list = list
    },
    del() {
      let ids = this.list.map(item => {
        return item.WorkDocId
      })
      let flag = []
      this.list.forEach(item => {
        if (item.Status == 3) {
          if (!flag.includes('已审核')) {
            flag.push('已审核')
          }
        }
        if (item.Status == 4) {
          if (!flag.includes('生产中')) {
            flag.push('生产中')
          }
        }
        if (item.Status == 5) {
          if (!flag.includes('已完成')) {
            flag.push('已完成')
          }
        }
        if (item.Status == 6) {
          if (!flag.includes('终止通知')) {
            flag.push('终止通知')
          }
        }
        if (item.Status == 7) {
          if (!flag.includes('终止完成')) {
            flag.push('终止完成')
          }
        }
      })
      if (flag.length > 0) {
        this.$message.warning(`勾选的单据包含${flag.join(',')}内容`)
        return
      }
      this.$confirm('确认删除所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.api.delete({ ids }).then(res => {
          if (res.Code == 0) {
            this.$message.success('删除成功')
            this.reload()
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },

    querySearch(queryString, cb) {
      var restaurants = this.restaurants
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    handleSelect(row, item) {
      row.ProductionDpId = item.id
      row.ProductionDpValue = item.value
    }
  }
}
</script>